import React from "react";
import "./DeleteAccount.css";
import DelightLogo from "../../assets/images/delight-logo.png";

const APP_NAME = "Flirtolo";
const COMPANY_NAME = "Lankovate";
const CONTACT_EMAIL = "sanduntharakag1@gmail.com";
const LAST_UPDATED = "22 November 2025";

export default function DeleteAccount() {
  return (
    <div className="delete-page">
      <div className="delete-container">
        {/* Header */}
        <div className="delete-header">
          <img src={DelightLogo} alt="Flirtolo Logo" className="delete-logo" />
          <h1 className="delete-title">Delete Your {APP_NAME} Account</h1>
          <p className="delete-meta">Last updated: {LAST_UPDATED}</p>
        </div>

        {/* Intro */}
        <p className="delete-paragraph">
          <strong>{APP_NAME}</strong> is a dating app developed and maintained
          by <strong>{COMPANY_NAME}</strong>. You can request deletion of your
          account and associated personal data at any time.
        </p>

        {/* How to delete */}
        <h2 className="delete-section-title">How to Delete Your Account</h2>
        <p className="delete-paragraph">
          You can delete your account directly inside the app:
        </p>

        <ol className="delete-steps">
          <li>
            Open the <strong>{APP_NAME}</strong> app.
          </li>
          <li>
            Go to <strong>Profile</strong> tab.
          </li>
          <li>
            Tap <strong>Terminate Account</strong>.
          </li>
          <li>
            Select <strong>Delete my account permanently</strong>.
          </li>

          <li>Confirm deletion when prompted.</li>
        </ol>

        <p className="delete-paragraph">
          If you can’t access the app, you may request deletion by emailing us
          at{" "}
          <a className="delete-link" href={`mailto:${CONTACT_EMAIL}`}>
            {CONTACT_EMAIL}
          </a>{" "}
          using the subject: <strong>“Delete my Flirtolo account”</strong>.
          Please send the email from the same Google account you used to sign
          in.
        </p>

        {/* What gets deleted */}
        <h2 className="delete-section-title">What Data Will Be Deleted</h2>
        <p className="delete-paragraph">
          When your account is deleted, we permanently remove:
        </p>

        <ul className="delete-list">
          <li>
            Your profile details (name, bio, gender, birth date, preferences)
          </li>
          <li>Your photos and uploaded images</li>
          <li>Your location data (latitude/longitude, matching coordinates)</li>
          <li>Your swipes, likes, matches, and interactions</li>
          <li>Your device tokens linked to your account</li>
          <li>Your chat messages (removed)</li>
        </ul>

        {/* What may be kept */}
        <h2 className="delete-section-title">What Data May Be Retained</h2>
        <p className="delete-paragraph">
          Some data may be retained only when required by law or for safety:
        </p>

        <ul className="delete-list">
          <li>
            <strong>Payment records</strong> processed via PayHere are retained
            by PayHere according to Sri Lankan banking and tax regulations.
          </li>
          <li>
            <strong>Abuse or safety logs</strong> may be kept in anonymized form
            for up to <strong>90 days</strong> to prevent fraud or harmful
            activity.
          </li>
        </ul>

        {/* Deletion timeline */}
        <h2 className="delete-section-title">Deletion Timeline</h2>
        <p className="delete-paragraph">
          Account deletion is processed immediately after confirmation in the
          app. In rare cases, server cleanup may take up to{" "}
          <strong>7 days</strong>.
        </p>

        {/* Contact */}
        <h2 className="delete-section-title">Contact Us</h2>
        <p className="delete-paragraph">
          If you have questions about deletion or your privacy, contact us:
        </p>

        <p className="delete-paragraph">
          📧{" "}
          <a className="delete-link" href={`mailto:${CONTACT_EMAIL}`}>
            {CONTACT_EMAIL}
          </a>
        </p>
      </div>
    </div>
  );
}
